module.exports = __webpack_public_path__ + "img/guide04.7149f3e7.png";